import { Injectable, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { UserService } from '../shared/services/user.service';

import firebase from 'firebase/compat/app';
import 'firebase/compat/remote-config';
import { FirebaseService } from 'src/app/shared/services/firebase.service';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private readonly cookieService = inject(CookieService);
  private readonly usrSvc = inject(UserService);
  private readonly firebaseSvc = inject(FirebaseService);

  checkForUpdates() {
    this.firebaseSvc.firebaseReady$.subscribe((listo) => {
      if (!listo) return;

      const currentVersion = this.cookieService.get('appVersion');
      const remoteConfig = firebase.remoteConfig();

      remoteConfig.fetchAndActivate().then(() => {
        const remoteVersion = remoteConfig.getValue('app_version').asString();

        if (!currentVersion) {
          this.cookieService.set('appVersion', remoteVersion);
          return this.clearCacheAndReload();
        }

        if (currentVersion && currentVersion !== remoteVersion) {
          this.SwalFireMessage(`Nueva version`, `Se ha detectado de que hay una nueva versión de la aplicación "${remoteVersion}".
            \nSe procederá a cerrar la sesión actual y recargar la página.`).then((result) => {
            if (result.isConfirmed) {
              this.cookieService.set('appVersion', remoteVersion);
              this.clearCacheAndReload();
            }
          });
        }
      }).catch(err => console.error('Error obteniendo versión de Remote Config:', err));
    });
  }

  clearCacheAndReload() {
    if ('caches' in window) {
      // delete all cache
      caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          caches.delete(cacheName);
        });
      });
    }

    window.location.reload();
    this.usrSvc.logout();
  }

  SwalFireMessage(title: string, text: string): Promise<SweetAlertResult> {
    return Swal.fire({
      title: title,
      html: `<div class="swal2-content-custom">${text}</div>`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCancelButton: false,
      confirmButtonText: 'Entendido',
      confirmButtonColor: '#296BA1',
      customClass: {
        title: 'swal2-title-custom',
        popup: 'swal2-popup-custom',
        confirmButton: 'swal2-confirm-custom',
        actions: 'swal2-actions-custom',
      },
    });
  }
}